export const locale = {
  lang: 'zh1',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'INST_1':'下載問題模板',
         'INST_2':'對模板進行必要的更改',
         'INST_3':'加載問題模板',
         'BTN_DESC_PLAN':'問題模板',
         'BUSC_PLAN_TEX':'單擊此處搜索模板問題',
         'TEMP_CARG_TIT':'模板信息',
         'TOT_PREG':'總問題數',
         'TOT_PREG_MODI':'已修改的問題總數',
         'TOT_PREG_NUE':'新問題總數',
         'TEMP_CARG_TIT_CAR':'已加載模板信息',
         'COMPL_PAS_SIN_MODI':'您尚未進行任何修改。 您一定要完成此步驟?',
         'SUCC_CAR_PLAN':'模板已成功加載。 請完成此步驟',
         'COMPLE_PASO_CON_MODI':'您確定要完成當前輸入的更改嗎？',
         'NO_MODIF':'不要修改此單元格內容',
         'ERROR_CARGA': '無法上載該文件，在一個或多個受限單元格中檢測到修改，請再次下載模板，然後進行所需的修改而無需修改受限單元格。\n\n受限單元格包含註釋，指示不應修改其內容',
         'FORALL_EXCEDIDAS': '檢測到加載的模板中存在的4All實踐數量超過了允許的實踐數量，僅加載了與允許的最大數量相對應的實踐 ',
         'OPCIONDEMOGRAFICOS': '此單元格必須包含人口統計目錄表中未更改的值',
         'CARGANDO_PREGUNTAS': '從模板加載問題'
      },
      'CATALOGO_IDIOMAS':{
        'z1':'簡體中文',
         'z2':'繁體中文',
         'ko':'韓文',
         'ja':'日語',
         'pt':'葡萄牙語',
         'en':'英語',
         'fr':'法語',
         'de':'德語',
         'it':'意大利語',
         'es':'西班牙文',
         'tr':'土耳其語',
         'ms':'馬來語',
         'ro':'羅馬尼亞語',
         'vi':'越南',
         'bg':'保加利亞語',
         'hi':'Hindi',
         'ru':'俄語',
         'mn':'蒙古語',
         'nl': '荷蘭語',
         'ar': '阿拉伯',
         'ua': '烏克蘭',
         'id': '印度尼西亞',
      },
      'HOJAS_EXCEL':{
       'Instrucciones': '說明',
       'Catalogo':'目錄',
       'Detalles': '細節',
       'CatDemograficos': '人口目錄',
       'Nps':'Nps',
       'Reactivos':'聲明',
       'Control':'控制',
       'Demograficos':'受眾特徵',
       'Abiertas':'打開',
       'Forall':'對全部',
       'Adicionales':'額外',
     },
     'COLUMNAS_H_CATA':{
       'ClaveIdiomas':'語言科',
       'NombreIdiomas':'語言名稱',
        'IDTipoPregunta':'問題類型ID',
        'TiposPreguntas':'問題類型',
        'ClaveTipoElemento':'元素類型鍵',
        'TiposElementos':'元素類型',
       'CONTEM_TIP_PREG':{
       '1':'NPS /控制/附加問題（多項選擇，一個答案）',
        '2_1':'NPS /控制/開放式問題,開放文本類型',
        '2_2':'NPS /控件/開放式問題,數字文本類型',
        '3':'反應類型問題',
        '4':'人口類型問題（多項選擇,一個答案）',
        '5':'練習4全部',
        '6':'其他問題（多項選擇,多項答案）',
       },
       'CONTEM_TIP_SEGM':{
       'question':'問題文本',
        'answer_1':'答案1的文字',
        'answer_2':'答案2的文字',
        'answer_n':'答案n的文字',
        'practice':'實踐文本4All',
        'description':'實踐4All的描述文字',
        'statement_1':'練習4All的問題1',
        'statement_2':'練習4All的問題2',
       }
     },
     'COLUMNAS_SECCION':{
      'Id':	'Id',
      'TipoDePregunta':	'問題類型',
      'PalabrasClave':	'關鍵字',
      'NuevaPregunta':	'新問題',
      'Eliminable':	'可消除的',
      'Editable':	'可編輯的',
      'RespuestaObligatoria':	'必修課',
      'MostrarPregunta':	'顯示問題',
      'Dimension':	'尺寸',
      'Competencia':	'權限',
      'Subcompetencia':	'子權限',
      'TipoDemografico':	'類型人口',
      'practice':	'實踐',
      'description':	'描述',
      'statement_1':	'statement_1',
      'statement_2':	'statement_2',
      'question':	'題',
      'answer':	'回答',
      'OpcionOtro': '回答類型“其他”'

     }
    }
  }
};
